import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'czDatePipe',
    standalone: false
})
export class czDatePipe implements PipeTransform {
  transform(date: string, format: string = 'dd.MM.y'): string {
    let datePipe: DatePipe = new DatePipe("en-US");
    return datePipe.transform(date, format)!;
  }
}
